import BranchSelect from "../components/branchSelect";

const HeaderLayout: React.FC<{
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  additionalStyles?: string | null;
  branches?: any[];
  selectedBranch?: string | null;
  setSelectedBranch?: (branch: string | null) => void;
  allUserBranches?: string;
  showBranchesDropDown?: boolean;
  showAllBranches?: boolean;
  isBranchesLoading?: boolean;
  subDivAdditionalStyles?: string;
}> = ({
  title,
  subtitle,
  children,
  additionalStyles,
  branches,
  selectedBranch,
  setSelectedBranch,
  allUserBranches,
  showBranchesDropDown = false,
  showAllBranches = true,
  isBranchesLoading = false,
  subDivAdditionalStyles,
}) => {
  return (
    <div
      className={`flex flex-col md:flex-row items-start mb-6 gap-4 ${additionalStyles}`}
    >
      <div className="flex-1">
        <h1 className="page-title">{title}</h1>
        <p className="page-subtitle">{subtitle}</p>
      </div>
      <div
        className={`flex flex-col md:flex-row items-stretch md:items-center gap-2 w-full md:w-auto ${subDivAdditionalStyles}`}
      >
        {isBranchesLoading && showBranchesDropDown && (
          <div
            className={`w-full md:w-[324px] h-10 flex items-center justify-center text-sm text-gray-500 border border-[#D5D7DA] rounded-lg bg-gray-50`}
          >
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
            Loading branches...
          </div>
        )}
        {showBranchesDropDown && !isBranchesLoading && (
          <BranchSelect
            fullWidth={true}
            branches={branches || []}
            selectedBranch={selectedBranch ? Number(selectedBranch) : null}
            onBranchChange={(branchId) =>
              setSelectedBranch?.(branchId?.toString() || "")
            }
            isLoading={isBranchesLoading}
            showAllBranches={showAllBranches}
            allBranchesValue={allUserBranches}
            className="w-full md:w-[324px] h-10 px-3 py-2 text-sm border border-[#D5D7DA] rounded-lg bg-white focus:outline-none"
            placeholder="Select branch"
          />
        )}

        {children}
      </div>
    </div>
  );
};

export default HeaderLayout;
